"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

require("../../assets/css/components/ob-timeline-step.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Timeline = function Timeline(_ref) {
  var data = _ref.data,
      classNameProp = _ref.className,
      vertical = _ref.vertical;
  var className = (0, _clsx["default"])('ob-timeline', {
    'ob-vertical-timeline': vertical
  }, classNameProp);
  return _react["default"].createElement("ul", {
    className: className
  }, data.map(function (v, index) {
    return _react["default"].createElement("li", {
      key: "timeline-".concat(index)
    }, _react["default"].createElement("i", {
      className: "time-status-icon"
    }, _react["default"].createElement("img", {
      src: v.stepIcon
    })), _react["default"].createElement("div", {
      className: "ob-step-text-wrap"
    }, v.title ? _react["default"].createElement("p", null, v.title) : '', v.subTitle ? _react["default"].createElement("small", null, v.subTitle) : '', v.body ? v.body : ''));
  }));
};

Timeline.defaultProps = {
  data: [],
  className: '',
  vertical: false
};
Timeline.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    subTitle: _propTypes["default"].string,
    body: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    stepIcon: _propTypes["default"].string
  })),
  className: _propTypes["default"].string,
  vertical: _propTypes["default"].bool
};
var _default = Timeline;
exports["default"] = _default;